export interface emailTemplateRegister {
    venueid: string;
    scheduledsessionid: string;
    ddmmyyyyhhmm: string;
    reason: string;
    emailcontent: string;
    emailsubject: string;
}

export class cEmailTemplateRegister implements emailTemplateRegister{
    venueid: string;
    scheduledsessionid: string;
    ddmmyyyyhhmm: string;
    reason: string;
    emailcontent: string;
    emailsubject: string;
}   
        

//The undated register has no session occurrence to target, so this payload carries only the
//session itself - it maps to POST /sendtemplateregisterall.
export interface emailTemplateRegisterAll {
    venueid: string;
    scheduledsessionid: string;
    emailcontent: string;
    emailsubject: string;
}

export class cEmailTemplateRegisterAll implements emailTemplateRegisterAll {
    venueid: string;
    scheduledsessionid: string;
    emailcontent: string;
    emailsubject: string;
}
